import { render, staticRenderFns } from "./SpecialMajor.vue?vue&type=template&id=047b2ae0&scoped=true"
import script from "./SpecialMajor.vue?vue&type=script&lang=js"
export * from "./SpecialMajor.vue?vue&type=script&lang=js"
import style0 from "./SpecialMajor.vue?vue&type=style&index=0&id=047b2ae0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047b2ae0",
  null
  
)

export default component.exports